/*
 * Copyright (c) 2022 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import {
    DevicesAction,
    DevicesActionType,
    downloadDevicesListAsExcelErrorAction,
    downloadDevicesListAsExcelSuccessAction,
    fetchDevicesListPageErrorAction,
    fetchDevicesListPageSuccessAction,
} from '../actions/devicesActions';
import { RootState } from '../store.typings';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { DevicesListRequestParams } from '../api/devices/devicesClient.typing';
import { DevicesState } from '../reducers/devicesReducer';
import { from, of } from 'rxjs';
import { devicesClient } from '../api/devices/devicesClient';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';

type DevicesEpic = Epic<DevicesAction, DevicesAction, RootState>;

export const fetchDevicesListPageEpic: DevicesEpic = (action$, state$) => {
    return action$.pipe(
        ofType(DevicesActionType.FETCH_NEXT_PAGE_START, DevicesActionType.APPLY_FILTERS),
        switchMap(() => {
            const state = state$.value.devicesReducer;
            const searchParams = makeDevicesListRequestParams(state);

            return from(devicesClient.listDevices(searchParams)).pipe(
                map((list) => fetchDevicesListPageSuccessAction(list)),

                catchError((err: AxiosError) =>
                    of(
                        fetchDevicesListPageErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.devicesListNotFound')),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(DevicesActionType.EXIT_REGISTRY_DEVICES_LIST_PAGE)),
            );
        }),
    );
};

function makeDevicesListRequestParams(state: DevicesState): DevicesListRequestParams {
    return {
        ...state.filterParams,
        limit: state.limit,
        afterKeyFactoryNumber: state.afterKeyFactoryNumber,
    };
}

export const downloadDevicesListEpic: DevicesEpic = (action$, state) => {
    return action$.pipe(
        ofType(DevicesActionType.DOWNLOAD_EXCEL_START),
        switchMap(() => {
            return from(devicesClient.downloadDevicesAsExcel({ ...state.value.devicesReducer.filterParams })).pipe(
                map(() => downloadDevicesListAsExcelSuccessAction()),

                catchError((err: AxiosError) =>
                    of(
                        downloadDevicesListAsExcelErrorAction(
                            parseError(err, i18n.t('downloadings.errors.requestToCreateFileFailed')),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(DevicesActionType.EXIT_REGISTRY_DEVICES_LIST_PAGE)),
            );
        }),
    );
};
